// Says how a mixed condition list actually evaluates.
//
// `parseConditionsToString` joins conditions with no parentheses, so SQL applies
// its own precedence and AND binds tighter than OR. A list drawn as equal rows,
// top to bottom, therefore implies a reading the SQL does not honour.
//
// This appears only when the list really is mixed, which the form cannot produce:
// `SignalsRules` offers `+ AND` or `+ OR` but never both, so anything built here
// is a pure conjunction or a pure disjunction and reads correctly as it stands.
// A mixed list arrives from the advanced mode, from imported YAML, or from data
// that predates the form. Those are exactly the cases where the flat drawing is
// wrong and nothing on screen said so.
import React from 'react';

import { Connected, groupByConnector, needsBrackets } from './conditionGroups';
import './conditionGroupingNote.css';

function ConditionGroupingNote({ conditions }: { conditions: Connected[] }) {
  if (!needsBrackets(conditions)) return null;

  // Positions rather than condition text: the rows are in this order directly
  // below, so a number points at one unambiguously and stays short.
  let position = 0;
  const groups = groupByConnector(conditions).map((group) =>
    group.map(() => {
      position += 1;
      return position;
    })
  );

  return (
    <p className="cgn">
      <span className="cgn-flag">Mixed and/or</span> SQL groups these as{' '}
      <b>
        {groups
          .map((group) =>
            group.length > 1 ? `(${group.join(' and ')})` : `${group[0]}`
          )
          .join(' or ')}
      </b>
      , not one row after another. Counting from the first condition below.
    </p>
  );
}

export default ConditionGroupingNote;
